import Button from "@/components/Button";
import { useOnboardingContext } from "@/contexts/OnboardingContext";
import { useState } from "react";
import RecipeSelectionFollowUpStep from "./RecipeSelectionFollowUpStep";

const RecipeSelectionStep = ({
  stepData,
  handleContinue,
  recipeSelectionStepAnswers,
}: {
  stepData: any;
  handleContinue?: (answer?: any) => void;
  recipeSelectionStepAnswers: any[];
}) => {
  const { setUserAnswer, addDynamicStep } = useOnboardingContext();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (!stepData) return null;

  const handleSelect = (answer: any) => {
    setSelectedId(answer.id);

    sessionStorage.setItem(
      "onboardingRecipeSelection",
      JSON.stringify({
        id: answer.id,
        title: answer.title,
      })
    );

    setUserAnswer("recipeSelection", answer);

    const followUpData = recipeSelectionStepAnswers.find((entry) =>
      entry.linkedRecipeSelection?.some(
        (linked: any) => linked.id === answer.id
      )
    );

    const followUpKey = `recipeSelectionFollowUp-${answer.id}`;

    if (followUpData) {
      addDynamicStep({
        key: followUpKey,
        image: followUpData.linkedOptionImages?.[0],
        isFollowUpStep: true,
        isSkippable: false,
        component: () => (
          <RecipeSelectionFollowUpStep
            stepData={followUpData}
            handleContinue={handleContinue}
          />
        ),
      });
    }

    handleContinue && handleContinue(answer);
  };
  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col justify-center md:pl-10 lg:justify-center">
      <h2 className="pb-6 font-spatial text-xl font-medium md:pt-5 md:text-3xl">
        {stepData.heading}
      </h2>

      <div className="space-y-2">
        {stepData.cookingPreferences?.map((answer: any) => {
          const isSelected = selectedId === answer.id;

          return (
            <button
              key={answer.id}
              onClick={() => handleSelect(answer)}
              className={`w-full rounded-full border px-6 py-2 text-left font-body text-sm text-black transition md:text-base ${
                isSelected
                  ? "border-zinc-300 bg-zinc-100"
                  : "border-zinc-300 hover:bg-zinc-100"
              }`}
            >
              {answer.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default RecipeSelectionStep;
